import { render, staticRenderFns } from "./_loginBody.vue?vue&type=template&id=07af5a5a&scoped=true"
import script from "./_loginBody.vue?vue&type=script&lang=js"
export * from "./_loginBody.vue?vue&type=script&lang=js"
import style0 from "./_loginBody.vue?vue&type=style&index=0&id=07af5a5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07af5a5a",
  null
  
)

export default component.exports